import type { ChangeEvent } from 'react';

/** composition 中（ref または nativeEvent.isComposing）なら true → 親への onChange を抑止 */
export function shouldSuppressChangeDuringComposition(params: {
  isComposingRef: boolean;
  nativeEventIsComposing: boolean;
}): boolean {
  return params.isComposingRef || params.nativeEventIsComposing;
}

/**
 * controlled 時の表示値。
 * draft がある間は draft を優先（composition 中、および確定後に親 value が追いつくまでの間）。
 */
export function resolveDisplayedValue(params: {
  isControlled: boolean;
  draft: string | null;
  propsValue: string | number | readonly string[] | undefined;
}): string | number | readonly string[] | undefined {
  const {
    isControlled,
    draft,
    propsValue
  } = params;
  if (!isControlled) {
    return undefined;
  }
  if (draft !== null) {
    return draft;
  }
  return propsValue;
}

/** compositionEnd 直後の change が同値なら二重 emit を抑止 */
export function shouldSkipDuplicateChangeAfterCompositionEnd(params: {
  lastEmittedValue: string | null;
  nextValue: string;
}): boolean {
  return params.lastEmittedValue !== null && params.nextValue === params.lastEmittedValue;
}

/** composition 確定時に親 onChange へ渡す最小の ChangeEvent を組み立てる */
export function createInputChangeEvent(input: HTMLInputElement): ChangeEvent<HTMLInputElement> {
  return {
    target: input,
    currentTarget: input
  } as ChangeEvent<HTMLInputElement>;
}